import { render, staticRenderFns } from "./BulkInvite.vue?vue&type=template&id=4623131d&scoped=true&"
import script from "./BulkInvite.vue?vue&type=script&lang=js&"
export * from "./BulkInvite.vue?vue&type=script&lang=js&"
import style0 from "./BulkInvite.vue?vue&type=style&index=0&id=4623131d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623131d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pawan/Vizmo/Max/dashboard-old/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VEditDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VInput } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDataTable,VEditDialog,VFlex,VForm,VIcon,VInput,VLayout,VSelect,VSnackbar,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
